import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RolesService } from '../services/roles.service';
import { SystemRole } from '../models/roles';

@Injectable({
  providedIn: 'root',
})
export class ExternalGuard implements CanActivate {
  constructor(private rolesService: RolesService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.rolesService.roles.pipe(
      map((roles) => {
        if (roles.includes(SystemRole.EXTERNAL)) {
          // Redirect external users away from Home → ExternalHome
          return this.router.parseUrl('/external');
        }
        return true; // allow normal users to Home
      })
    );
  }
}